<div class="container">
  <h1 class="page-title"><span class="icon"><i class="fas fa-scroll"></i></span>{{ 'Terms.View.Header' | translate }}
  </h1>
  <div class="terms-container">
    <label for="password">{{ 'Terms.View.TermsType' | translate }}</label>
    <p-dropdown [options]="termsTypeOptions" (onChange)="typeChange($event)" class="ml-4" [(ngModel)]="selectedTermsType"></p-dropdown>
    <div [innerHTML]="showContent | safeHtml">
    </div>
  </div>
